try
{
  document.execCommand("BackgroundImageCache", false, true);
}
catch(err) {}